import { createContext, useContextSelector } from 'use-context-selector';

const GlobalStateCS = createContext(null);
const useGlobalStateSelector = (selector) => useContextSelector(GlobalStateCS, selector);

const words = require('./words.json');

const stateKeysToSetAddress = [
  ['configure', 'addressMain'],
  ['login', 'addressMain'],
  ['active', 'addressMain'],
  ['sendMona', 'addressFrom'],
  ['sendXmp', 'addressFrom'],
  ['sendToken', 'addressFrom'],
  ['issuance', 'addressIssuer'],
  ['unregisteredAddress', 'address'],
];

const stateKeysToSetUserName = [
  ['configure', 'userName'],
];

function getInitialConfigureState(addressMain = '') {
  return {
    addressMain,
    userName: '',
    readTheTermsAndConditions: false,
    readPrivacyPolicy: false,
    acceptedVersionOfTheTermsAndConditions: null,
    acceptedVersionOfPrivacyPolicy: null,
    displayAddressSection: false,
    mnemonic: null,
    status: null,
  };
}

function getInitialIssuanceState() {
  return {
    issueMode: 'issueMonacard',
    assetType: 'tokenNameLeftToTheSystem',
    imagesNew: {
      monacard: null,
      monacardUrl: null,
    },
    addressIssuer: '',
    parent: '',
    subAsset: '',
    assetCommon: '',
    amount: { face: '', value: '' },
    monacardName: '',
    monacardIssuerName: '',
    monacardDescription: '',
    monacardTag: '',
    divisible: false,
    listed: true,
    vendable: true,
    reassignable: true,
  };
}

export {
  GlobalStateCS,
  useGlobalStateSelector,
  words,
  getInitialConfigureState,
  getInitialIssuanceState,
  stateKeysToSetAddress,
  stateKeysToSetUserName,
};
